'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _years = require('../actions/years');

var _api = require('../api');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchYears),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchYear),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(editYear),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(createYear),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(fetchYearsRequest),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(fetchYearRequest),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(editYearRequest),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(createYearRequest);

function fetchYears() {
    var response;
    return regeneratorRuntime.wrap(function fetchYears$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/years');

                case 3:
                    response = _context.sent;
                    _context.next = 6;
                    return (0, _effects.put)(_years.actionCreators.fetchYearsSucceeded(response.data));

                case 6:
                    _context.next = 12;
                    break;

                case 8:
                    _context.prev = 8;
                    _context.t0 = _context['catch'](0);
                    _context.next = 12;
                    return (0, _effects.put)(_years.actionCreators.fetchYearsFailed());

                case 12:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 8]]);
}

function fetchYear(_ref) {
    var yearId = _ref.yearId;
    var response;
    return regeneratorRuntime.wrap(function fetchYear$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/years/' + yearId);

                case 3:
                    response = _context2.sent;
                    _context2.next = 6;
                    return (0, _effects.put)(_years.actionCreators.fetchYearSucceeded(response.data));

                case 6:
                    _context2.next = 12;
                    break;

                case 8:
                    _context2.prev = 8;
                    _context2.t0 = _context2['catch'](0);
                    _context2.next = 12;
                    return (0, _effects.put)(_years.actionCreators.fetchYearFailed());

                case 12:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this, [[0, 8]]);
}

function editYear(_ref2) {
    var yearId = _ref2.yearId,
        changes = _ref2.changes,
        redirect = _ref2.redirect;
    return regeneratorRuntime.wrap(function editYear$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return (0, _effects.call)(_api.request, 'put', '/years/' + yearId, changes);

                case 3:
                    _context3.next = 5;
                    return (0, _effects.put)(_years.actionCreators.editYearSucceeded());

                case 5:
                    if (!redirect) {
                        _context3.next = 8;
                        break;
                    }

                    _context3.next = 8;
                    return (0, _effects.call)(redirect);

                case 8:
                    _context3.next = 14;
                    break;

                case 10:
                    _context3.prev = 10;
                    _context3.t0 = _context3['catch'](0);
                    _context3.next = 14;
                    return (0, _effects.put)(_years.actionCreators.editYearFailed());

                case 14:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this, [[0, 10]]);
}

function createYear(_ref3) {
    var year = _ref3.year,
        redirect = _ref3.redirect;
    return regeneratorRuntime.wrap(function createYear$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.prev = 0;
                    _context4.next = 3;
                    return (0, _effects.call)(_api.request, 'post', '/years/', year);

                case 3:
                    _context4.next = 5;
                    return (0, _effects.put)(_years.actionCreators.createYearSucceeded());

                case 5:
                    if (!redirect) {
                        _context4.next = 8;
                        break;
                    }

                    _context4.next = 8;
                    return (0, _effects.call)(redirect);

                case 8:
                    _context4.next = 14;
                    break;

                case 10:
                    _context4.prev = 10;
                    _context4.t0 = _context4['catch'](0);
                    _context4.next = 14;
                    return (0, _effects.put)(_years.actionCreators.createYearFailed());

                case 14:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this, [[0, 10]]);
}

function fetchYearsRequest() {
    return regeneratorRuntime.wrap(function fetchYearsRequest$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _effects.takeLatest)(_years.actionTypes.FETCH_YEARS_REQUEST, fetchYears);

                case 2:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function fetchYearRequest() {
    return regeneratorRuntime.wrap(function fetchYearRequest$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(_years.actionTypes.FETCH_YEAR_REQUEST, fetchYear);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function editYearRequest() {
    return regeneratorRuntime.wrap(function editYearRequest$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return (0, _effects.takeLatest)(_years.actionTypes.EDIT_YEAR_REQUEST, editYear);

                case 2:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function createYearRequest() {
    return regeneratorRuntime.wrap(function createYearRequest$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(_years.actionTypes.CREATE_YEAR_REQUEST, createYear);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

exports.default = [fetchYearsRequest, fetchYearRequest, editYearRequest, createYearRequest];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvZWZmZWN0cy95ZWFycy5qcyJdLCJuYW1lcyI6WyJmZXRjaFllYXJzIiwiZmV0Y2hZZWFyIiwiZWRpdFllYXIiLCJjcmVhdGVZZWFyIiwiZmV0Y2hZZWFyc1JlcXVlc3QiLCJmZXRjaFllYXJSZXF1ZXN0IiwiZWRpdFllYXJSZXF1ZXN0IiwiY3JlYXRlWWVhclJlcXVlc3QiLCJyZXF1ZXN0IiwicmVzcG9uc2UiLCJhY3Rpb25DcmVhdG9ycyIsImZldGNoWWVhcnNTdWNjZWVkZWQiLCJkYXRhIiwiZmV0Y2hZZWFyc0ZhaWxlZCIsInllYXJJZCIsImZldGNoWWVhclN1Y2NlZWRlZCIsImZldGNoWWVhckZhaWxlZCIsImNoYW5nZXMiLCJyZWRpcmVjdCIsImVkaXRZZWFyU3VjY2VlZGVkIiwiZWRpdFllYXJGYWlsZWQiLCJ5ZWFyIiwiY3JlYXRlWWVhclN1Y2NlZWRlZCIsImNyZWF0ZVllYXJGYWlsZWQiLCJhY3Rpb25UeXBlcyIsIkZFVENIX1lFQVJTX1JFUVVFU1QiLCJGRVRDSF9ZRUFSX1JFUVVFU1QiLCJFRElUX1lFQVJfUkVRVUVTVCIsIkNSRUFURV9ZRUFSX1JFUVVFU1QiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBOztBQUNBOztBQUNBOzttREFFVUEsVTtvREFXQUMsUztvREFVQUMsUTtvREFlQUMsVTtvREFlQUMsaUI7b0RBSUFDLGdCO29EQUlBQyxlO29EQUlBQyxpQjs7QUEvRFYsU0FBVVAsVUFBVjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsMkJBRytCLG1CQUFLUSxZQUFMLEVBQWMsS0FBZCxFQUFxQixRQUFyQixDQUgvQjs7QUFBQTtBQUdjQyw0QkFIZDtBQUFBO0FBQUEsMkJBS2Msa0JBQUlDLHNCQUFlQyxtQkFBZixDQUFtQ0YsU0FBU0csSUFBNUMsQ0FBSixDQUxkOztBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLDJCQU9jLGtCQUFJRixzQkFBZUcsZ0JBQWYsRUFBSixDQVBkOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQVdBLFNBQVVaLFNBQVY7QUFBQSxRQUFzQmEsTUFBdEIsUUFBc0JBLE1BQXRCO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSwyQkFHK0IsbUJBQUtOLFlBQUwsRUFBYyxLQUFkLGNBQStCTSxNQUEvQixDQUgvQjs7QUFBQTtBQUdjTCw0QkFIZDtBQUFBO0FBQUEsMkJBSWMsa0JBQUlDLHNCQUFlSyxrQkFBZixDQUFrQ04sU0FBU0csSUFBM0MsQ0FBSixDQUpkOztBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLDJCQU1jLGtCQUFJRixzQkFBZU0sZUFBZixFQUFKLENBTmQ7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBVUEsU0FBVWQsUUFBVjtBQUFBLFFBQXFCWSxNQUFyQixTQUFxQkEsTUFBckI7QUFBQSxRQUE2QkcsT0FBN0IsU0FBNkJBLE9BQTdCO0FBQUEsUUFBc0NDLFFBQXRDLFNBQXNDQSxRQUF0QztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLDJCQUdjLG1CQUFLVixZQUFMLEVBQWMsS0FBZCxjQUErQk0sTUFBL0IsRUFBeUNHLE9BQXpDLENBSGQ7O0FBQUE7QUFBQTtBQUFBLDJCQUtjLGtCQUFJUCxzQkFBZVMsaUJBQWYsRUFBSixDQUxkOztBQUFBO0FBQUEseUJBT1lELFFBUFo7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQSwyQkFRa0IsbUJBQUtBLFFBQUwsQ0FSbEI7O0FBQUE7QUFBQTtBQUFBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsMkJBV2Msa0JBQUlSLHNCQUFlVSxjQUFmLEVBQUosQ0FYZDs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFlQSxTQUFVakIsVUFBVjtBQUFBLFFBQXVCa0IsSUFBdkIsU0FBdUJBLElBQXZCO0FBQUEsUUFBNkJILFFBQTdCLFNBQTZCQSxRQUE3QjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLDJCQUdjLG1CQUFLVixZQUFMLEVBQWMsTUFBZCxFQUFzQixTQUF0QixFQUFpQ2EsSUFBakMsQ0FIZDs7QUFBQTtBQUFBO0FBQUEsMkJBS2Msa0JBQUlYLHNCQUFlWSxtQkFBZixFQUFKLENBTGQ7O0FBQUE7QUFBQSx5QkFPWUosUUFQWjtBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBLDJCQVFrQixtQkFBS0EsUUFBTCxDQVJsQjs7QUFBQTtBQUFBO0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSwyQkFXYyxrQkFBSVIsc0JBQWVhLGdCQUFmLEVBQUosQ0FYZDs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFlQSxTQUFVbkIsaUJBQVY7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsMkJBQ1UseUJBQVdvQixtQkFBWUMsbUJBQXZCLEVBQTRDekIsVUFBNUMsQ0FEVjs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFJQSxTQUFVSyxnQkFBVjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSwyQkFDVSx5QkFBV21CLG1CQUFZRSxrQkFBdkIsRUFBMkN6QixTQUEzQyxDQURWOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQUlBLFNBQVVLLGVBQVY7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsMkJBQ1UseUJBQVdrQixtQkFBWUcsaUJBQXZCLEVBQTBDekIsUUFBMUMsQ0FEVjs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFJQSxTQUFVSyxpQkFBVjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSwyQkFDTyx5QkFBV2lCLG1CQUFZSSxtQkFBdkIsRUFBNEN6QixVQUE1QyxDQURQOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOztrQkFLZSxDQUNYQyxpQkFEVyxFQUVYQyxnQkFGVyxFQUdYQyxlQUhXLEVBSVhDLGlCQUpXLEMiLCJmaWxlIjoieWVhcnMuanMiLCJzb3VyY2VSb290IjoiL3NyYyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNhbGwsIHB1dCwgdGFrZUxhdGVzdCB9IGZyb20gJ3JlZHV4LXNhZ2EvZWZmZWN0cyc7XG5pbXBvcnQgeyBhY3Rpb25UeXBlcywgYWN0aW9uQ3JlYXRvcnMgfSBmcm9tICcuLi9hY3Rpb25zL3llYXJzJztcbmltcG9ydCB7IHJlcXVlc3QgfSBmcm9tICcuLi9hcGknO1xuXG5mdW5jdGlvbiogZmV0Y2hZZWFycygpIHtcblxuICAgIHRyeSB7XG4gICAgICAgIGNvbnN0IHJlc3BvbnNlID0geWllbGQgY2FsbChyZXF1ZXN0LCAnZ2V0JywgJy95ZWFycycpO1xuXG4gICAgICAgIHlpZWxkIHB1dChhY3Rpb25DcmVhdG9ycy5mZXRjaFllYXJzU3VjY2VlZGVkKHJlc3BvbnNlLmRhdGEpKTtcbiAgICB9IGNhdGNoIChlcnJvcikge1xuICAgICAgICB5aWVsZCBwdXQoYWN0aW9uQ3JlYXRvcnMuZmV0Y2hZZWFyc0ZhaWxlZCgpKTtcbiAgICB9XG59XG5cbmZ1bmN0aW9uKiBmZXRjaFllYXIoeyB5ZWFySWQgfSkge1xuXG4gICAgdHJ5IHtcbiAgICAgICAgY29uc3QgcmVzcG9uc2UgPSB5aWVsZCBjYWxsKHJlcXVlc3QsICdnZXQnLCBgL3llYXJzLyR7eWVhcklkfWApO1xuICAgICAgICB5aWVsZCBwdXQoYWN0aW9uQ3JlYXRvcnMuZmV0Y2hZZWFyU3VjY2VlZGVkKHJlc3BvbnNlLmRhdGEpKTtcbiAgICB9IGNhdGNoIChlcnJvcikge1xuICAgICAgICB5aWVsZCBwdXQoYWN0aW9uQ3JlYXRvcnMuZmV0Y2hZZWFyRmFpbGVkKCkpO1xuICAgIH1cbn1cblxuZnVuY3Rpb24qIGVkaXRZZWFyKHsgeWVhcklkLCBjaGFuZ2VzLCByZWRpcmVjdCB9KSB7XG5cbiAgICB0cnkge1xuICAgICAgICB5aWVsZCBjYWxsKHJlcXVlc3QsICdwdXQnLCBgL3llYXJzLyR7eWVhcklkfWAsIGNoYW5nZXMpO1xuXG4gICAgICAgIHlpZWxkIHB1dChhY3Rpb25DcmVhdG9ycy5lZGl0WWVhclN1Y2NlZWRlZCgpKTtcblxuICAgICAgICBpZiAocmVkaXJlY3QpIHtcbiAgICAgICAgICAgIHlpZWxkIGNhbGwocmVkaXJlY3QpO1xuICAgICAgICB9XG4gICAgfSBjYXRjaCAoZXJyb3IpIHtcbiAgICAgICAgeWllbGQgcHV0KGFjdGlvbkNyZWF0b3JzLmVkaXRZZWFyRmFpbGVkKCkpO1xuICAgIH1cbn1cblxuZnVuY3Rpb24qIGNyZWF0ZVllYXIoeyB5ZWFyLCByZWRpcmVjdCB9KSB7XG5cbiAgICB0cnkge1xuICAgICAgICB5aWVsZCBjYWxsKHJlcXVlc3QsICdwb3N0JywgJy95ZWFycy8nLCB5ZWFyKTtcblxuICAgICAgICB5aWVsZCBwdXQoYWN0aW9uQ3JlYXRvcnMuY3JlYXRlWWVhclN1Y2NlZWRlZCgpKTtcbiAgICAgICAgXG4gICAgICAgIGlmIChyZWRpcmVjdCkge1xuICAgICAgICAgICAgeWllbGQgY2FsbChyZWRpcmVjdCk7XG4gICAgICAgIH1cbiAgICB9IGNhdGNoIChlcnJvcikge1xuICAgICAgICB5aWVsZCBwdXQoYWN0aW9uQ3JlYXRvcnMuY3JlYXRlWWVhckZhaWxlZCgpKTtcbiAgICB9XG59XG5cbmZ1bmN0aW9uKiBmZXRjaFllYXJzUmVxdWVzdCgpIHtcbiAgICB5aWVsZCB0YWtlTGF0ZXN0KGFjdGlvblR5cGVzLkZFVENIX1lFQVJTX1JFUVVFU1QsIGZldGNoWWVhcnMpO1xufVxuXG5mdW5jdGlvbiogZmV0Y2hZZWFyUmVxdWVzdCgpIHtcbiAgICB5aWVsZCB0YWtlTGF0ZXN0KGFjdGlvblR5cGVzLkZFVENIX1lFQVJfUkVRVUVTVCwgZmV0Y2hZZWFyKTtcbn1cblxuZnVuY3Rpb24qIGVkaXRZZWFyUmVxdWVzdCgpIHtcbiAgICB5aWVsZCB0YWtlTGF0ZXN0KGFjdGlvblR5cGVzLkVESVRfWUVBUl9SRVFVRVNULCBlZGl0WWVhcik7XG59XG5cbmZ1bmN0aW9uKiBjcmVhdGVZZWFyUmVxdWVzdCgpIHtcblx0eWllbGQgdGFrZUxhdGVzdChhY3Rpb25UeXBlcy5DUkVBVEVfWUVBUl9SRVFVRVNULCBjcmVhdGVZZWFyKTtcbn1cblxuXG5leHBvcnQgZGVmYXVsdCBbXG4gICAgZmV0Y2hZZWFyc1JlcXVlc3QsXG4gICAgZmV0Y2hZZWFyUmVxdWVzdCxcbiAgICBlZGl0WWVhclJlcXVlc3QsXG4gICAgY3JlYXRlWWVhclJlcXVlc3Rcbl07Il19


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/years.js
// module id = 2232
// module chunks = 0